<div class="container-fluid p-0">
  <!-- Alert/Notice Panel - Hidden by default, can be toggled -->
   <div class="tab-description">
    Questions can’t be deleted while the project is Live. Switch to Setup to make changes. Rater changes are only allowed within the existing scale of the current primary questions.
   </div>
  <!-- <div class="alert alert-info alert-dismissible fade show mb-4" role="alert">
    <div class="d-flex">
      <div class="flex-shrink-0">
        <i class="fa fa-info-circle me-2 align-self-center"></i>
      </div>
      <div class="flex-grow-1 ms-2">
        <strong>Important Notes:</strong>
        <ol class="mb-0 mt-2">
          <li>Questions cannot be deleted if the project status is Live. Deletion is only supported in the Setup status.
          </li>
          <li>Please update the status to Setup before making any changes.</li>
          <li>Rater change is only supported on the scale already defined for the current primary questions.</li>
        </ol>
      </div>
    </div>
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div> -->

  <!-- Action Bar -->
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
    <!-- New Button -->
    <button class="btn create-question-btn" [disabled]="!isUserHasWriteAccess" (click)="openQuestionModal()">
      Create New Question
    </button>

    <!-- Search and Save Row -->
    <div class="d-flex align-items-center search-save-group">
      <div class="search-box me-2">
        <div class="input-group">
          <span class="input-group-text search-icon">
            <img src="./assets/images/search-icon.svg">
          </span>
          <input type="text" class="form-control search-input" placeholder="Search a question"
            [(ngModel)]="searchText" [disabled]="!questions || questions.length === 0">
        </div>
      </div>
      <button class="btn save-btn" 
              [disabled]="!isUserHasWriteAccess"
              [disabled]="!hasOrderChanged || isSaving" 
              [class.btn-primary]="hasOrderChanged && !isSaving"
              [class.btn-secondary]="!hasOrderChanged || isSaving"
              (click)="saveQuestions()">
        <span class="save-btn-new" *ngIf="!isSaving" style="color: inherit;">Save</span>
        <span *ngIf="isSaving" style="color: inherit;">
          <i class="fa fa-spinner fa-spin me-2"></i>Saving...
        </span>
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div class="text-center py-5" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading questions...</p>
  </div>
 
  <!-- Empty State -->
  <div class="empty-state" *ngIf="!loading && (!questions || filteredQuestions.length === 0)">
    <div class="error-message">
      No Interaction or Visibility groups created. To create a group click on the “New” button.
    </div>
  </div>

  <!-- Questions List -->
  <div class="questions-container" *ngIf="!loading && filteredQuestions && filteredQuestions.length > 0" cdkDropList
    [cdkDropListData]="filteredQuestions" [cdkDropListDisabled]="!isUserHasWriteAccess" (cdkDropListDropped)="onDrop($event)">

    <ng-container *ngFor="let question of filteredQuestions">
      <div class="question-card shadow-sm" *ngIf="!question?.group_id && !question?.is_deleted && !question?.readOnly" cdkDrag [cdkDragData]="question">
        <div class="question-main-row">
          <!-- Drag Handle -->
          <div class="drag-handle" cdkDragHandle title="Drag to reorder">
      <svg class="icon-set">
                        <use [attr.xlink:href]="'./assets/images/icons.svg#reorder'"></use>
                      </svg>
          </div>

          <!-- Main Content -->
          <div class="question-list-content">
            <div class="question-list-title">{{ question.text || question.question }}</div>
            <div class="question-list-id">Question ID: {{ question.field_id }}</div>
          </div>

          <!-- Badge and Actions -->
          <div class="question-list-right">
            <span *ngIf="question.is_primary_rating" class="primary-badge">Primary Rating</span>
            <span *ngIf="question.is_primary_comment" class="primary-badge">Primary Comment</span>
            <div class="question-actions">
              <button class="btn action-btn" (click)="showQuestionInfo(question)" [attr.aria-label]="'View details for: ' + (question.text || question.question)" title="Question ID: {{question.field_id}}">
                <!-- <i class="fa fa-info-circle"></i> -->
                <img src="./assets/images/info-icon.svg">
              </button>
              <button class="btn action-btn" (click)="copyInteraction(question)" [disabled]="isUnsupportedForCopy(question)" [attr.aria-label]="'Copy question: ' + (question.text || question.question)" title="Create a copy of this question">
                <!-- <i class="fa fa-copy"></i> -->
                <img src="./assets/images/clone.svg">
              </button>
              <button class="btn action-btn" (click)="editQuestion(question)" [attr.aria-label]="'Edit question: ' + (question.text || question.question)" title="Edit this question">
                <!-- <i class="fa fa-edit"></i> -->
                <img src="./assets/images/editIcon.svg">
              </button>
              <button class="btn action-btn" (click)="deleteQuestion(question)" *ngIf="canDeleteQuestion(question)" [attr.aria-label]="'Delete question: ' + (question.text || question.question)" title="Delete this question">
                <!-- <i class="fa fa-trash"></i> -->
                <img src="./assets/images/new-trash-can-outline.svg">
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Question Info Modal -->
<ng-template #questionInfoModal let-modal>
  <div class="modal-header border-bottom">
    <h5 class="modal-title">Question Details</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body" *ngIf="currentQuestion">
    <div class="info-item mb-3">
      <span class="info-label text-muted">Question ID</span>
      <span class="info-value fw-medium">{{ currentQuestion.field_id }}</span>
    </div>

    <div class="info-item mb-3">
      <span class="info-label text-muted">Component Type</span>
      <span class="info-value fw-medium">{{ currentQuestion.component_type || 'Not specified' }}</span>
    </div>

    <div class="info-item mb-3">
      <span class="info-label text-muted">Primary Rating</span>
      <span class="info-value fw-medium">
        <span class="badge" [ngClass]="currentQuestion.is_primary_rating ? 'bg-success' : 'bg-secondary'">
          {{ currentQuestion.is_primary_rating ? 'Yes' : 'No' }}
        </span>
      </span>
    </div>

    <div class="info-item mb-3">
      <span class="info-label text-muted">Primary Comment</span>
      <span class="info-value fw-medium">
        <span class="badge" [ngClass]="currentQuestion.is_primary_comment ? 'bg-success' : 'bg-secondary'">
          {{ currentQuestion.is_primary_comment ? 'Yes' : 'No' }}
        </span>
      </span>
    </div>

    <div class="info-item mb-3">
      <span class="info-label text-muted">Required</span>
      <span class="info-value fw-medium">
        <span class="badge" [ngClass]="currentQuestion.is_mandatory ? 'bg-success' : 'bg-secondary'">
          {{ currentQuestion.is_mandatory ? 'Yes' : 'No' }}
        </span>
      </span>
    </div>

    <div class="info-item mb-3">
      <span class="info-label text-muted">Show on Dashboard</span>
      <span class="info-value fw-medium">
        <span class="badge" [ngClass]="currentQuestion.is_displayed_on_dashboard ? 'bg-success' : 'bg-secondary'">
          {{ currentQuestion.is_displayed_on_dashboard ? 'Yes' : 'No' }}
        </span>
      </span>
    </div>

    <div class="info-item mb-0" *ngIf="currentQuestion.sub_questions && currentQuestion.sub_questions.length > 0">
      <span class="info-label text-muted">Options</span>
      <ul class="info-list list-group list-group-flush mt-2">
        <li class="list-group-item d-flex justify-content-between align-items-center ps-0 py-2"
          *ngFor="let option of currentQuestion.sub_questions">
          {{ option.text }}
          <span class="badge bg-secondary" *ngIf="option.is_hidden">Hidden</span>
        </li>
      </ul>
    </div>
  </div>

  <div class="modal-footer border-top">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>

<app-create-new-question *ngIf="isQuestionModalOpen" [question]="modalData.question" [isEditMode]="isEditMode" (closeEvent)="closeModal()"></app-create-new-question>

